var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"caja-pdf\">\r\n    <h4> <strong>Para acceder tendrás que actualizar tu suscripción.</strong> </h4>\r\n    <hr>\r\n    <p>\r\n        Para cambiarla comunicate al: <strong>(011) 5199-4787</strong> <br>\r\n        O desde el exterior a:  <br>\r\n        <a href=\"mailto:accesodigital@lanacion.com.ar\">accesodigital@lanacion.com.ar</a>\r\n    </p>\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/actualizar_suscripcion.hbs
// module id = 483
// module chunks = 0 1